import { trackRemoveFromCart } from '../../../../../../shared/analytics/e-commerce/trackRemoveFromCart';
import { IParkingProduct } from '../../../../../domain/parking-product/models/IParkingProduct';
import { adaptParkingProductToItem } from './adapters/adaptParkingProductToItem';

export function trackRemoveProduct(removedParkingProduct: IParkingProduct) {
	trackRemoveFromCart({
		items: [adaptParkingProductToItem(removedParkingProduct)],
	});
}
